import { EnumTechLanguage } from 'tdc-web-backend/enums/enums';
import { Stack } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import CustomChip from '../../../../../../../../../components/custom-chip/CustomChip';
import { mapTechLanguage } from '../../../../../../../../../utils/enums';
import { truncate } from '../../../../../../../../../utils/helpers';
import CompanyTechLanguagesEditModal from './components/CompanyTechLanguagesEditModal';
import useUserCompany from '../../../../../../../../../utils/hooks/useUserCompany';
import { CHIP_LABEL_TRUNCATE_VALUE } from '../../../../../../../../../utils/constants';

interface CompanyTechLanguages {
  isEditModalOpen: boolean;
  setIsEditModalOpen: Dispatch<SetStateAction<boolean>>;
}

const CompanyTechLanguages = ({ isEditModalOpen, setIsEditModalOpen }: CompanyTechLanguages) => {
  const { company: companyData } = useUserCompany();

  return (
    <Stack
      direction="row"
      gap={1}
      flexWrap="wrap"
      alignItems="flex-start"
      justifyContent="flex-start"
    >
      <>
        {isEditModalOpen && (
          <CompanyTechLanguagesEditModal
            isEditModalOpen={isEditModalOpen}
            setIsEditModalOpen={setIsEditModalOpen}
          />
        )}

        {companyData?.techLanguages?.map((language: EnumTechLanguage) => (
          <CustomChip
            key={language}
            tooltipTitle={mapTechLanguage.get(language)}
            label={
              language &&
              truncate(mapTechLanguage.get(language) as string, CHIP_LABEL_TRUNCATE_VALUE as number)
            }
            sx={{ width: 'fit-content', textTransform: 'capitalize' }}
          />
        ))}
      </>
    </Stack>
  );
};

export default CompanyTechLanguages;
